import Vue from 'vue'
import App from './App.vue'
// 引入组件库
import VueEasytable from "vue-easytable";

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n //en
// 导入路由
import router from './router/index'
// 导入vuex
import store from './store/index'
// 移动端适配
import 'lib-flexible'

// meta 设置
import VueMeta from 'vue-meta';

import $ from 'jquery';

import moment from 'moment'
import _ from 'lodash'
// 全局样式
import "vue-easytable/libs/theme-default/index.css";
import './assets/style/variable.scss'
import './assets/iconfont/iconfont.css'
import './assets/style/index.scss'

//国际化
import i18n from "@/language/i18n";


//全局组件
import headerView from "@/components/Header";
import footView from "@/components/Foot";
Vue.component('headerView', headerView);
Vue.component('footView', footView);

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.metaInfo) {
    store.commit("CAHNGE_META_INFO",to.meta.metaInfo)
  }
  next()
})

//判断环境
try{
  if(window.navigator && window.navigator.userAgent.indexOf("miniProgram")>=0){
    store.commit("SET_ENV","miniprogram")
  }

}catch(err){
  console.log("判断环境",err)
}


// publicFont/飞花宋体.ttf   publicFont/index.vue

Vue.config.productionTip = false

Vue.prototype.$moment = moment
Vue.prototype.$lodash = _

Vue.use(ElementUI, { locale })

Vue.use(VueEasytable);
Vue.use(VueMeta);

new Vue({
  router,
  store,
  i18n,
  metaInfo() {
    return {
      // 默认meta标签
      // title: this.$store.state.metaInfo.title || "UPS",
      meta: [
        {
          name: "keywords",
          content: this.$store.state.metaInfo.keywords || "UPS阿帕·全球专业模组制造商",
        },
        {
          name: "description",
          content: this.$store.state.metaInfo.description||"UPS阿帕作为国内知名汽车照明品牌，致力于提供汽车夜间照明安全解决方案，专注于汽车照明产品，研发、生产、销售，和改灯技术培训及线下加盟。同时提供专业改灯咨询服务，解决了车主在选购改灯产品时烦恼的兼容性和安装问题，阿帕打通了线上购买、线下安装的O2O闭环生态模式是行业内率先打造从产品到安装售后一体化服务体系者，现处于行业领先地位。",
        },
      ],
    }

  },
  render: h => h(App),

}).$mount('#app')
/**
 * 
 // 默认meta标签
    
 */